@import (reference) '../../../../../constants/spacing.module.less';
@import (reference) '../grid-layouts.module.less';

.shipment-details-grid {
  flex: 1;
  display: grid;
  justify-content: start;
  column-gap: @space-24;

  &.four-columns {
    .shipment-details-four-column-grid-layout();
  }

  &.three-columns {
    .shipment-details-three-column-grid-layout();
  }

  &.two-columns {
    .shipment-details-two-column-grid-layout();
  }

  &.one-column {
    .shipment-details-one-column-grid-layout();
  }
}

.divider {
  display: none;
}
